import apiClient from "./apiClient";
import {
  FormGenerationDashboardResponse,
  FormGenerationQueryParams,
  FormGenerationExportParams,
} from "../types/form-generation-usage.types";

/**
 * Fetch Form Generation Usage Dashboard data
 *
 * Backend uses dateFrom/dateTo query params (not startDate/endDate).
 * Returns raw backend format.
 */
export const getFormGenerationDashboard = async (
  params?: FormGenerationQueryParams
): Promise<FormGenerationDashboardResponse> => {
  const searchParams = new URLSearchParams();
  if (params?.dateFrom) searchParams.append("dateFrom", params.dateFrom);
  if (params?.dateTo) searchParams.append("dateTo", params.dateTo);

  const queryString = searchParams.toString();
  const url = `/grants/admin/form-generations${queryString ? `?${queryString}` : ""}`;

  const { data } = await apiClient.get<FormGenerationDashboardResponse>(url);
  return data;
};

/**
 * Export Form Generation Usage data as CSV
 *
 * Backend uses dateFrom/dateTo query params.
 * Returns a Blob for download.
 */
export const exportFormGenerationCsv = async (
  params: FormGenerationExportParams
): Promise<Blob> => {
  const searchParams = new URLSearchParams();
  searchParams.append("dateFrom", params.dateFrom);
  searchParams.append("dateTo", params.dateTo);

  const { data } = await apiClient.get(
    `/grants/admin/form-generations/export?${searchParams.toString()}`,
    {
      responseType: "blob",
    }
  );

  return data;
};

/**
 * Download helper - triggers browser download
 */
export const downloadCsvBlob = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

/**
 * Generate CSV filename based on date range
 */
export const generateFormGenerationCsvFilename = (
  dateFrom: string,
  dateTo: string
): string => {
  const start = dateFrom.split("T")[0];
  const end = dateTo.split("T")[0];
  return `form-generations-${start}-${end}.csv`;
};
